import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import AIRoomSetup from "./AIRoomSetup.tsx";
import AIRoomGame from "./AIRoomGame.tsx";
import { useState } from "react";
import { useAIRoomSocket } from "./hooks/useAIRoomSocket.js";
import WaitingForPromptsRender from "./Components/WaitingForPromptsRender.js";
import AIManualEntry from "./AIManualEntry.tsx";

interface AIRoomProps {
  roomName: string;
  setRoomState: (state: string) => void;
  AIRoomState: string;
  setAIRoomState: (state: string) => void;
  socket: any;
  containerHeight: number;
  showInfoMessage: (
    type: string,
    message: string,
    isAdd: boolean,
    duration?: string,
    isDelay?: boolean,
  ) => void;
  cameFromJoin: boolean;
  setCameFromJoin: (cameFromJoin: boolean) => void;
  fetchString: string;
}

function AIRoom({
  roomName,
  setRoomState,
  AIRoomState,
  setAIRoomState,
  socket,
  containerHeight,
  showInfoMessage,
  cameFromJoin,
  setCameFromJoin,
  fetchString,
}: AIRoomProps) {
  const [waitingForPrompts, setWaitingForPrompts] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useAIRoomSocket(socket, roomName, setWaitingForPrompts);

  //   If settings not defined send to setting
  return (
    <>
      {waitingForPrompts && <WaitingForPromptsRender />}

      {AIRoomState === "done" && (
        <AIRoomGame
          roomName={roomName.toLowerCase()}
          setRoomState={setRoomState}
          socket={socket}
          setAIRoomState={setAIRoomState}
          containerHeight={containerHeight}
          fetchString={fetchString}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          showInfoMessage={showInfoMessage}
        />
      )}

      {AIRoomState === "setup" && (
        <AIRoomSetup
          roomName={roomName.toLowerCase()}
          setRoomState={setRoomState}
          fetchString={fetchString}
          socket={socket}
          setAIRoomState={setAIRoomState}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          showInfoMessage={showInfoMessage}
        />
      )}
      {AIRoomState === "manual entry" && (
        <AIManualEntry
          roomName={roomName.toLowerCase()}
          socket={socket}
          showInfoMessage={showInfoMessage}
          setAIRoomState={setAIRoomState}
          cameFromJoin={cameFromJoin}
          setRoomState={setRoomState}
          setCameFromJoin={setCameFromJoin}
        />
      )}
    </>
  );
}

export default AIRoom;
